import React from 'lib/react';
import { EVButton, EVClear, makeStyles } from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import { useDispatch } from 'lib/redux';
import { openCancelOrderDialog } from 'features/cancel-order-dialog/CancelOrder.actions';

export const useStyles = makeStyles((theme) => ({
  cancelBtn: {
    width: '125px',
    backgroundColor: theme.evPalette.salt[100],
    borderColor: theme.evPalette.charcoal[300],
    padding: '4px 20px 4px 20px',
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
  cancelBtnLabel: { gap: '8px' },
}));

function CancelButton({ reportId, reportAddress }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOrderCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(openCancelOrderDialog(reportId, reportAddress));
  };

  return (
    <EVButton
      id={`cancelBtn-${reportId}`}
      variant="outlined"
      color="primary"
      className={classes.cancelBtn}
      classes={{ label: classes.cancelBtnLabel }}
      onClick={handleOrderCancel}
    >
      <EVClear />
      {t('common_cancel')}
    </EVButton>
  );
}

CancelButton.propTypes = {
  reportId: PropTypes.number.isRequired,
  reportAddress: PropTypes.string.isRequired,
};

export default CancelButton;
